// USA
export const locale = {
    GENERAL: {
      APP_TITLE: "VIMS",
      UNEXPECTED_ERROR: "Unexpected error! Please contact the technical team if the problem persist.",
      FORBIDDEN:"You do not have the right permissions.",
      DELETE_CONFIRM: "Please confirm delete!",
      SELECT_ALL_CONFIRM: "Please confirm all select/deselect!",
      SUCCESS_MESSAGE: "Success!",
      SUCCESS_UPDATE_MESSAGE: "Successfully updated!",
      LABELS: {
        CONTINUE_BUTTON: "Continue",
        BACK_BUTTON: "Back",
        DOWNLOAD_BUTTON: "Download",
        CREATE_BUTTON: "Create",
        ALL: "All",
        SELECT_ALL_OPTION: "Select All",
        PHONE: "Phone",
        SAVE: "Save",
        EDIT: "Edit",
        EDIT_BUTTON: "Edit",
        CLOSE_BUTTON: "Close",
        RELOAD_PAGE: "Reload Page",
        ORDER: "Order",
        OFFER_GROUP: "Offer Group",
        SEARCH: "Search",
        SHOW_ONLY_SELECTED: "Only Selected",
        ADD_NEW_BELOW: "Add New Below",
        HEADERS: "Headers",
        SEARCH: "Search",
        TEMPERATURE: "Temperature",
        ORDER: "Order",
        LEAD: "Lead",
        FILTER: "Filter",
        CONVERTED_FROM: "Converted From",
        EXCHANGE_RATE: "Exchange Rate",
        UNCONVERTED_PRICE: "Unconverted Price",
        NAME: "Name",
        ID: "ID",
        EMAIL: "Email",
        TYPE: "Type",
        DATE_TYPE: "Date Type",
        FOUND: "Found",
        CONTACTS: "Contacts",
        PERSONALIZED_WEEKLY_OFFER_CONTACTS: "PWO Contacts",
        COMPANY: "Company",
        SELECTED: "Selected",
        WEEK: "Week",
        START_DATE: "Start Date",
        END_DATE: "End Date",
        LIST_OF_THE_CONTACTS: "List of the Contacts",
        EXPAND_ALL: "Expand All",
        COLLAPSE_ALL: "Collapse All",
        ADDITIONAL_COLUMNS: "Additional Columns",
        FILTERS: "Filters",
        RESET_COLUMN_WIDTHS: "Reset column widths",
        REFRESH_DATA: "Refresh Data",
        CLOSE: "Close",
        CLOSE_AND_SELECT: "Close and Select",
        STATUS: "Status",
        TEMPERATURE: "Temperature",
        CREATED_BY: "Created By",
        CREATED_DATE: "Created Date",
        PUBLISHED_BY: "Published By",
        PUBLISHED_DATE: "Published Date",
        OPEN: "Open",
        COPY: "Copy",
        PRINT_VIEW: "Print View",
        DOWNLOAD: "Download",
        PREVIEW: "Preview",
        SHOW_RELATED_CONTACTS: "Show Related Contacts",
        CURRENCY: "Currency",
        COUNTRY: "Country",
        EXPIRATION_DATE: "Expiration Date",
        TRANSPORT_COST: "Transport Cost",
        LAST_UPDATED: "Last Updated",
        ADD_TRANSPORT_DATA: "Add Transport Data",
        SAME_COUNTRIES: "Same Countries",
        CUSTOM_TRANSPORT_COST: "Custom Transport Cost",
        LOADING_COUNTRY: "Loading Country",
        CLIENT_PRICE: "Client Price",
        MISSING_TRANSPORT_COSTS: "Missing Transport Costs",
        DELETE: "Delete",
        CONTACTS_LOADING: "Contacts Loading",
        REFRESH_PRICE_LIST: "Refresh Price List",
        NEW_POSITIONS: "New Positions",
        UPDATED_POSITIONS: "Updated Positions",
        DELETED_POSITIONS: "Deleted Positions",
        NO_CHANGES: "No Changes",
        APPROVE: "Approve",
        COST_BASE: "Cost Base",
        LEAD_OFFER: "Lead Offer",
        OFFER: "Offer",
        INCOTERMS: "Incoterms",
        DESTINATION_COUNTRY: "Destination Country",
        PRICE_LISTS: "Price Lists",
        REQUEST_QUOTE: "Request a quote",
        DATE: "Date",
        SHOW_OLDER: "Show Older",
        MATCH_TYPE: "Match Type",
        PRICE: "Price",
        POSITION_NAME: "Position Name",
        TRANSPORT_PRICE: "Transport Price",
        TOTAL_PRICE: "Total Price",
        PRICE_LIST: "Price List",
        REFRESH: "Refresh",
        OPEN_IN_LIVE_LIST: "Open in Live List",
        IMPORT_TYPE: "Import Type",
        CHOOSE_FILE: "Choose File",
        DOWNLOAD_TEMPLATE: "Download Template",
        PLEASE_CHOOSE_FILE: "Please choose file",
        COPY: "Copy",
        ACTIVE: "Active",
        INACTIVE: "Inactive",
        YES: "Yes",
        NO: "No",
        CONTACT: "Contact",
      },
      TABLE: {
        OPTIONS_COLUMN: "Options",
        TOTAL_ITEMS: "Total Items",
      }
    },
    TRANSLATOR: {
        SELECT: "Select your language"
    },
    MENU: {
        NEW: "new",
        ACTIONS: "Actions",
        CREATE_POST: "Create New Post",
        PAGES: "Pages",
        FEATURES: "Features",
        APPS: "Apps",
        DASHBOARD: "Dashboard",
        ASIDE: {
            OFFER: "Offer",
            QUICK_ADD: "Quick Add",
            LIST_OFFERS: "List Offers",
            LIVE_LIST: "Live List",
            PRICE_LISTS: "Price Lists",
            PRICING: "Pricing",
            COMPANIES: "Companies",
            COMPANY_CONTACTS: "Company Contacts",
            PIPELINES: "Pipelines",
            CREATE_PIPELINE: "Create Pipeline",
            LIST_PIPELINES: "List Pipelines",
            DEALS: "Deals",
            DEALS_LIST: "Deals List",
            DEAL_TYPES: "Deal Types",
            DEAL_STATUSES: "Deal Statuses",
            DEAL_DOCUMENT_TYPES: "Deal Document Types",
            SETTINGS: "Settings",
            USERS: "Users",
            TEAMS: "Teams",
            ALIASES: "Aliases",
            MAPPINGS: "Mappings",
            UNIT_CONVERSIONS: "Unit Conversions",
            TRANSPORT_DATA: "Transport Data",
            FIELD_TAGS: "Field Tags",
            INCOTERMS: "Incoterms",
            PRICE: "Price"
        }
    },
    AUTH: {
        GENERAL: {
            WELCOME: "Welcome to Adex VIMS!",
            WELCOME_DESCRIPTION:
                "Virtual Inventory Management System for offer solutions",
            FOOTER_LEFT: "Adex",
            OR: "Or",
            SUBMIT_BUTTON: "Submit",
            NO_ACCOUNT: "Don't have an account?",
            SIGNUP_BUTTON: "Sign Up",
            FORGOT_BUTTON: "Forgot Password",
            BACK_BUTTON: "Back",
            PRIVACY: "Privacy",
            LEGAL: "Legal",
            CONTACT: "Contact"
        },
        LOGIN: {
            TITLE: "Login Account",
            DESCRIPTION:
                "Please contact the website Administrator to obtain username and password.",
            VALID_EMAIL: "A valid email address is required.",
            VALID_PASSWORD: "Password is required.",
            BUTTON: "Sign In",
            CREDENTIALS_ERROR: "Wrong username or password.",
            GOOGLE_EMAIL_ERROR: "Invalid account.",
            VALID_PASSWORD_CONFIRM: "Passwords must match",
            LOGIN_BUTTON: "Login"
        },
        FORGOT: {
            TITLE: "Forgot Password?",
            DESC: "Success. Enter your email to reset your password",
            SUCCESS: "Your account has been successfully reset.",
            BUTTON: "Send",
            SUCCESS_MESSAGE:
                "You have received an email with link to reset your password."
        },
        RESET: {
            TITLE: "Reset Password",
            BUTTON: "Save",
            SUCCESS_MESSAGE: "Success. Please login with your new password."
        },
        REGISTER: {
            TITLE: "Sign Up",
            DESC: "Enter your details to create your account",
            SUCCESS: "Your account has been successfuly registered."
        },
        INPUT: {
            EMAIL: "Email",
            FULLNAME: "Fullname",
            PASSWORD: "Password",
            CONFIRM_PASSWORD: "Confirm Password",
            USERNAME: "Username"
        },
        VALIDATION: {
            INVALID: "{{name}} is not valid",
            REQUIRED: "{{name}} is required",
            MIN_LENGTH: "{{name}} minimum length is {{min}}",
            AGREEMENT_REQUIRED: "Accepting terms & conditions are required",
            NOT_FOUND: "The requested {{name}} is not found",
            INVALID_LOGIN: "The login detail is incorrect",
            REQUIRED_FIELD: "Required field",
            MIN_LENGTH_FIELD: "Minimum field length:",
            MAX_LENGTH_FIELD: "Maximum field length:",
            INVALID_FIELD: "Field is not valid"
        }
    },
    PROFILE: {
      PROFILE_BUTTON: "Profile",
      LOG_OUT_BUTTON: "Sign Out",
      INFO_HEADER: "Profile Information",
      DISPLAY_PREFERENCES_HEADER: "Display Preferences",
      NAME_LABEL: "Name",
      EMAIL_LABEL: "Email"
    },
    OFFER: {
        TITLE: "Offer",
        SUB_TITLE: "Add New Offer",
        PREVIEW_TITLE: "Offer Preview",
        SECTION_GENERAL: "General",
        SECTION_TAGS: "Tags",
        SECTION_MAPPINGS: "Mapping Values",
        SECTION_NORMALIZE: "Derived Fields"
    },
    LIST_OFFERS: {
        TITLE: "List Offers",
        SUB_TITLE: "List All Offers",
        DATE: "Date",
        EXPIRE_DATE: "Expire Date",
        RAW: "Raw"
    },
    NEW_QUICK_OFFER: {
        TITLE: "Create Quick Offer",
        SUB_TITLE: "New Quick Offer"
    },
    USERS: {
        TITLE: "Users",
        SUB_TITLE: "Users",
        VIEW: "View User",
        SYSTEM_ADMIN: "System Admin",
        LABELS: {
          GOOGLE_LOGIN: "Google Login"
        }
    },
    TEAMS: {
        TITLE: "Teams",
        SUB_TITLE: "Teams",
        USERS: "Users",
        VIEW: "View Team",
        NEED_OFFERS_PERRMISSION_WARNING: "Need Offers Permission",
    },
    COMPANY_CONTACTS: {
        TITLE: "Company Contacts",
        SUB_TITLE: "Company Contacts",
        CREATE: "Create Company Contact",
        EDIT: "Update Company Contact",
        VIEW: "View Company Contact",
        ROLE: "Role",
        INFORMATION: "Information",
    },
    COMPANIES: {
        TITLE: "Companies",
        CREATE: "Create Company",
        EDIT: "Update Company",
        VIEW: "View Company",
        ADD_NEW: "Add New Company",
        CREATED_MESSAGE: "Company {name} was added.",
        COMPANY_RANK: "Company Rank",
        COMPANY_TYPES: "Company Types",
        COMPANY_CONTACTS_COUNT: "Company Contacts Count",
        OPEN_CONTACTS: "Open Contacts",
        FILTERED_COMPANIES_COUNT: "{count} companies",
        NO_COMPANIES_FOR_CONTACTS: "No companies found for the current filters.",
        TOO_MANY_COMPANIES_FOR_CONTACTS: "More than {max} companies is too many. Please narrow your filters.",
        VAT: "VAT",
        CREDIT_LIMIT: "Credit Limit",
        ADDRESS: "Address",
        ADDRESS_BUILDER: "Build address",
        ADDRESS_BUILDER_TITLE: "Address builder",
        ADDRESS_BUILDER_HINT: "Fill in only the fields you need. The filled parts will be combined into one address.",
        ADDRESS_STREET: "Street address",
        ADDRESS_STREET_2: "Apartment, suite, unit, etc.",
        ADDRESS_CITY: "City",
        ADDRESS_STATE: "State / Province / Region",
        ADDRESS_POSTAL_CODE: "Postal code",
        ADDRESS_COUNTRY: "Country",
        ADDRESS_PREVIEW: "Preview",
        ADDRESS_PREVIEW_EMPTY: "Filled address parts will appear here.",
        ADDRESS_APPLY: "Apply to address",
        ADDRESS_CLEAR: "Clear fields",
        NOTES: "Notes",
        INFORMATION: "Information",
        WEBSITE: "Website",
        OWNED_BY: "Owned By",
        GENERAL_EMAILS: "General Emails",
        ADD_GENERAL_EMAIL: "Add General Email",
        EMAIL_TAGS: "Role",
    },
    PIPELINES: {
        TITLE: "Pipelines",
        CREATE: "Create Pipeline",
        EDIT: "Update Pipeline",
        VIEW: "View Pipeline",
        NO_STAGES_IN_PIPELINE: "No stages in this pipeline.",
        TOO_MANY_DEALS_WARNING:
            "This pipeline has {count} deals on the board. Performance may be slower with this many deals.",
        VIEW_BOARD: "Board",
        VIEW_TABLE: "Table",
        STAGES: "Stages",
        STAGE_NAME: "Stage name",
        STAGE_ORDER_INTEGER: "Order must be a whole number.",
        STAGE_ORDER_MIN: "Order must be 0 or greater.",
        ADD_STAGE: "Add stage",
        MIN_STAGES: "At least two stages are required.",
    },
    DEAL_TYPES: {
        TITLE: "Deal Types",
        CREATE: "Create Deal Type",
        EDIT: "Edit Deal Type",
        VIEW: "View Deal Type",
        SLUG: "Slug",
        TYPE: "Type",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_DISABLED: "System deal types cannot be edited.",
    },
    FIELD_TAGS: {
        TYPES_TITLE: "Field Tag Types",
        TAGS_TITLE: "Field Tags",
        CREATE_TYPE: "Create Field Tag Type",
        EDIT_TYPE: "Edit Field Tag Type",
        CREATE_TAG: "Create Field Tag",
        ADD_NEW: "Add new tag",
        EDIT_TAG: "Edit Field Tag",
        VIEW_TAG: "View Field Tag",
        MERGE_INTO_CURRENT_TOOLTIP: "Merge similar tags into this tag",
        MERGE_CURRENT_INTO_OTHER_TOOLTIP: "Merge this tag into another",
        MERGE_INTO_CURRENT_TITLE: "Merge tags into this tag",
        MERGE_CURRENT_INTO_OTHER_TITLE: "Merge this tag into another",
        MERGE_TAGS_TITLE: "Merge tags",
        PARENT: "Parent",
        CHILDREN: "Children",
        UPDATE_PARENT_CHILDREN_TITLE: "Update parent and children",
        UPDATE_PARENT_CHILDREN_TOOLTIP: "Update parent and children of this tag",
        CHILDREN_TITLE: "Children",
        NO_CHILDREN: "This tag has no children.",
        CURRENT_TAG: "Current tag",
        ANCESTORS_TITLE: "Ancestor Chain",
        NO_ANCESTORS: "This tag has no ancestors.",
        NO_MERGE_SUGGESTIONS: "No suggestions found with at least 50% similarity.",
        SELECT_TAGS_TO_MERGE_INTO_CURRENT: "Select tags to merge into this tag",
        SELECT_TARGET_TAG: "Select target tag",
        MERGE_BUTTON: "Merge",
        CANCEL_BUTTON: "Cancel",
    },
    INCOTERMS: {
        TITLE: "Incoterms",
        CREATE: "Create Incoterm",
        EDIT: "Edit Incoterm",
        VIEW: "View Incoterm",
        CODE: "Code",
        INCLUDE_TRANSPORT: "Include Transport",
        YES: "Yes",
        NO: "No",
    },
    DEAL_STATUSES: {
        TITLE: "Deal Statuses",
        CREATE: "Create Deal Status",
        EDIT: "Edit Deal Status",
        VIEW: "View Deal Status",
        SLUG: "Slug",
        TYPE: "Type",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_DISABLED: "System deal statuses cannot be edited.",
    },
    DEAL_DOCUMENT_TYPES: {
        TITLE: "Deal Document Types",
        CREATE: "Create Deal Document Type",
        EDIT: "Edit Deal Document Type",
        VIEW: "View Deal Document Type",
        SLUG: "Slug",
        TYPE: "Type",
        REQUIRED: "Required",
        SYSTEM: "System",
        CUSTOM: "Custom",
        SYSTEM_EDIT_LIMITED: "System document types can only have the Required field edited.",
    },
    DEALS: {
        TITLE: "Deals",
        TABLE: {
            PIPELINE: "Pipeline",
        },
        MODAL: {
            ADD_DEAL_BUTTON: "Add deal",
            DEAL_FALLBACK_TITLE: "Deal #{id}",
            NO_DEALS: "No deals",
            ADD_TITLE: "Add deal",
            EDIT_TITLE: "Edit deal",
            VIEW_TITLE: "View deal",
            DEAL_NAME: "Deal name",
            OWNERS: "Owners",
            OWNERS_REQUIRED: "At least one owner is required.",
            DEAL_NUMBER: "Deal number",
            ORGANIZATION: "Organization",
            SUPPLIER: "Supplier",
            SUPPLIERS: "Suppliers",
            CLIENT: "Client",
            CLIENTS: "Clients",
            PIPELINE: "Pipeline",
            STAGE: "Stage",
            MEAT: "Meat",
            DESCRIPTION: "Description",
            PRODUCTS: "Products",
            ADD_PRODUCT: "Add product",
            CONTAINER_ARRIVAL_DATE: "Container arrival date",
            CONTAINER_NUMBER: "Container number",
            LOADING_DATES: "Loading dates",
            LOADING_DATE: "Loading date",
            YEAR: "Year",
            YEAR_CREATED: "Year created",
            WEEK: "Week",
            ADD_LOADING_DATE: "Add loading date",
            NOTE: "Note",
            TYPE: "Type",
            INCOTERM: "Incoterm",
            LOCATION: "Location",
            STATUS: "Status",
            IS_PAID: "Paid",
            PAID_YES: "Yes",
            PAID_NO: "No",
            FILES: "Files",
            OTHER_FILES: "Other Files",
            TAB_INFORMATION: "Information",
            TAB_DOCUMENTS: "Documents",
            REQUIRED_DOCUMENT: "Required",
            MISSING_REQUIRED_DOCUMENT: "This document is required",
            UPLOAD_DOCUMENT_HINT: "Click or drag a file to upload",
            COMPLETE_MISSING_DOCUMENTS_CONFIRM: "Are you sure you want to complete this deal? The following required documents are missing: {documents}.",
            FILES_AVAILABLE_AFTER_SAVE: "Files can be uploaded after the deal is saved.",
            DROP_FILES_HINT: "Drag and drop files here or click to upload",
            NO_FILES: "No files uploaded",
        }
    },
    ALIASES: {
        TITLE: "Edit Aliases",
        SUB_TITLE: "Edit Aliases",
        LIST: "Aliases",
        TABLE_COLUMNS: {
          VALUE: "Original",
          FORMATTED_VALUE: "Clean",
          NUMBER_OF_TYPE: "Number of type"
        },
        EMPTY_VALUE_ERROR_MESSAGE: "Please fill all selected values!"
    },
    MAPPINGS: {
        EDIT: "Edit Mapping",
        CREATE: "Create Mapping",
        LIST: "Mappings",
        EDIT_VALUES: "Edit Mapping Values",
        EXPAND_HIDE_ALL: "Expand/Hide All",
        ADD_MAPPING_VALUE: "Add Mapping Value",
        EDIT_MAPPING_VALUE: "Edit Mapping Value",
        VALUE_LABEL: "Value",
        GROUP_VALUE_LABEL: "Group Value",
        GROUP_LABEL: "Group",
        PARENT_LABEL: "Parent",
        TAG: "Tag",
        DOWNLOAD_TEMPLATE: "Download Template",
        IMPORT_MAPPING: "Import Mapping",
        DOWNLOAD_BIG_FILE_CONFIRM: "The file is too big and if you try to import it, this may slow down the server.",
        LIVE_LIST_NOT_IMMEDIATELY_APPEARS: "The changes is not immediately appears in the live list. It may take a few seconds.",
    },
    UNIT_CONVERSIONS: {
        TITLE: "Unit Conversions",
        CREATE: "Create Unit Conversion",
        EDIT: "Edit Unit Conversion",
        VIEW: "View Unit Conversion",
        UNIT: "Unit",
        TO_KG: "To KG",
    },
    TRANSPORT_DATA: {
      TITLE: "Transport Data",
      ADD_TRANSPORT_DATA: "Add transport data",
      EDIT_TRANSPORT_DATA: "Edit transport data",
      COUNTRY_A: "Country A",
      COUNTRY_B: "Country B",
      DISTANCE: "Distance",
      PRICE: "Price",
    },
    LIVE_LIST: {
        TITLE: "Live List",
        COST_BASE: "Cost Base",
        WEIGHTED_AVERAGE_PRICE: "Weighted Average Price",
        MIN_PRICE_OF_RANK: "Min Price Of Rank",
        MAX_PRICE: "Max Price",
        APPROVED: "Approved",
        LEAD: "Lead",
        INDICATORS: {
            HAS_NEW_APPROVED_OFFERS: "New Approved Offers",
            HAS_NEW_NOT_APPROVED_OFFERS: "New Not Approved Offers",
            HAS_EXPIRED_OFFERS: "Expired Offers",
            AUTO_APPROVED: "Auto Approved",
        },
        FILTERS: {
            LAST_AUTO_UPDATED: "Last Auto Updated",
            MANNUALY_SET_COST_BASE: "Manually Set Cost Base",
            NEW_OFFERS_THAT_ARE_NOT_APPROVED: "New Offers That Are Not Approved",
            NEW_APPROVED_OFFERS_WITH_MANNUALY_SET_COST_BASE: "New Approved Offers With Manually Set Cost Base",
            NEWLY_ARRIVED_OFFERS: "Newly-arrived Offers",
        }
    },
    PRICE_LISTS: {
      LIST: "Price Lists",
      CREATE: "Create Price List",
      EDIT: "Edit Price List",
      ADD: "Add Price List",
      STEP_1: "Base",
      STEP_2: "Price List",
      STEP_3: "Preview",
      STEP_4: "Publish",
      FOR_GROUP_OF_CONTACTS: "Select Group of Contacts",
      DATA_LOSS_CONFIRM: "This action may cause data loss. Are you sure you want to continue?",
      COST_BASE: "Cost Base",
      TRANSPORT_COST: "Transport Cost",
      CLIENT_PRICE: "Client Price",
      WEIGHTED_AVERAGE_PRICE: "Weighted Average Price",
      MIN_PRICE_OF_RANK: "Min Price Of Rank",
      MAX_PRICE: "Max Price",
      LEAD: "Lead",
      PUBLISH_CONFIRM: "Are you sure you want to publish this price list?",
      PUBLISHED_TYPE: "Published Via",
      PUBLISHED_DATE: "Published Date",
      SHARE_TO_USERS: "Share to Users",
      SHARE_TO_TEAMS: "Share to Teams",
      PUBLISH_BUTTON: "Publish",
      INCLUDE_TRANSPORT_COST: "Transport Cost",
    },
    PRICING: {
        EDIT: "Edit Pricing",
        CREATE: "Create Pricing",
        LIST: "Pricing",
        ACTIVE: "Active",
        CREATED_BY: "Created By",
        PUBLISHED_BY: "Published By",
        EXPIRE_DATE: "Expire Date",
        PUBLISHED_DATE: "Published Date",
        CLONE: "Clone",
    },
};
